import { isNil } from 'lodash'

import { ADDITIONAL_DATA_KEY } from 'consts/chart'
import { ChartData } from 'types'

const DY_TOP_OFFSET = -20
const DY_BOTTOM_OFFSET = 16

export const calculateAdditionLabelPosition = (data: ChartData, chartValue: string) => {
  const firstDotValue = data[0]?.[ADDITIONAL_DATA_KEY]?.[chartValue].value
  const secondDotValue = data[1]?.[ADDITIONAL_DATA_KEY]?.[chartValue].value

  if (isNil(firstDotValue) || isNil(secondDotValue)) {
    return undefined
  }

  const isChartGrowingAtTheBeginning = secondDotValue > firstDotValue

  return {
    dy: isChartGrowingAtTheBeginning ? DY_BOTTOM_OFFSET : DY_TOP_OFFSET,
  }
}
